import React from 'react';
import './Charter.css';

const Charter = () => {
  const charterItems = [
    {
      title: "Respect absolu du prospect",
      description: "Nous nous engageons à ne jamais harceler, manipuler ou tromper les prospects. Chaque interaction doit apporter une réelle valeur ajoutée."
    },
    {
      title: "Personnalisation authentique",
      description: "Nous rejetons les approches \"one-size-fits-all\" et nous engageons à créer des messages véritablement adaptés au contexte et aux enjeux de chaque prospect."
    },
    {
      title: "Transparence totale",
      description: "Nous communiquons clairement sur qui nous sommes, qui nous représentons et l'objectif de notre démarche dès le premier contact."
    },
    {
      title: "Conformité RGPD exemplaire",
      description: "Nous respectons scrupuleusement la réglementation sur la protection des données et n'utilisons que des sources de données légitimes et conformes."
    },
    {
      title: "Valeur avant conversion",
      description: "Nous croyons fermement que la prospection efficace commence par l'apport de valeur réelle avant toute tentative de conversion."
    },
    {
      title: "Multi-canal sans omniprésence",
      description: "Nous orchestrons une présence cohérente sur plusieurs canaux sans créer de sentiment d'omniprésence invasive pour le prospect."
    },
    {
      title: "Qualification mutuelle",
      description: "Nous considérons la prospection comme un processus de qualification mutuelle, où l'objectif est de déterminer si une collaboration peut être bénéfique pour les deux parties."
    },
    {
      title: "Analyse et optimisation continue",
      description: "Nous nous engageons à analyser systématiquement les performances de nos actions et à optimiser en continu nos approches."
    },
    {
      title: "Respect de la concurrence",
      description: "Nous ne dénigrons jamais la concurrence et fondons notre argumentation uniquement sur la valeur objective de nos solutions."
    },
    {
      title: "Formation permanente",
      description: "Nous investissons continuellement dans la formation de notre collectif pour rester à la pointe des meilleures pratiques et technologies de prospection."
    }
  ];

  return (
    <section className="charter-section">
      <div className="charter-container">
        <div className="charter-header">
          <h1 className="charter-title">Charte Prosperian des bonnes pratiques de la prospection B2B</h1>
          <p className="charter-intro">
            Nos engagements pour une prospection éthique, respectueuse et efficace
          </p>
        </div>

        <div className="charter-content">
          <div className="charter-grid">
            {charterItems.map((item, index) => (
              <div key={index} className="charter-item">
                <div className="item-number">{index + 1}</div>
                <div className="item-content">
                  <h3 className="item-title">{item.title}</h3>
                  <p className="item-description">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="charter-cta">
        <div className="charter-container">
          <h2 className="cta-title">DÉCOUVREZ VOTRE POTENTIEL DE CROISSANCE</h2>
          <p className="cta-description">
            Rejoignez les entreprises qui mettent l'éthique au cœur de leur stratégie commerciale.
          </p>
          <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
            <button className="cta-button">OBTENIR MON SCORE</button>
          </a>
        </div>
      </div>

      <div className="charter-cta secondary">
        <div className="charter-container">
          <h2 className="cta-title">Prêt à transformer votre approche commerciale ?</h2>
          <p className="cta-description">
            Découvrez comment notre méthodologie peut s'adapter à vos enjeux spécifiques.
          </p>
          <div className="cta-buttons">
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
              <button className="cta-button">Demander une démo</button>
            </a>
            <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
              <button className="cta-button secondary">Tester mon éligibilité</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Charter; 